// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mtc-overlay {
  position: fixed;
  inset: 0;
  z-index: 1100;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 1.25rem 1rem;
  overflow-y: auto;
}

.mtc-modal {
  background: #fff;
  border-radius: 14px;
  width: 100%;
  max-width: 880px;
  margin: 1.5rem 0;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.22);
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 3rem);
}

.mtc-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.15rem 1.35rem;
  border-bottom: 1px solid var(--border);
  background: linear-gradient(180deg, #f0fdfa 0%, #fff 100%);
  border-radius: 14px 14px 0 0;
}

.mtc-modal__header h3 {
  margin: 0 0 0.25rem;
  font-size: 1.15rem;
  font-weight: 750;
  color: var(--text);
}

.mtc-modal__header p {
  margin: 0;
  font-size: 0.82rem;
  color: var(--text-muted);
}

.mtc-modal__close {
  width: 34px;
  height: 34px;
  border: 1px solid var(--border);
  background: #fff;
  border-radius: 8px;
  color: var(--text-muted);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.mtc-modal__close:hover {
  color: #0f766e;
  border-color: #0f766e;
}

.mtc-modal__body {
  overflow-y: auto;
  padding: 1rem 1.35rem 0.5rem;
}

.mtc-error {
  margin: 0 0 1rem;
  padding: 0.7rem 0.9rem;
  background: #fee2e2;
  color: #b91c1c;
  border-radius: 8px;
  font-size: 0.85rem;
}

.mtc-loading {
  margin: 0 0 1rem;
  padding: 0.7rem 0.9rem;
  background: #f0fdfa;
  color: #0f766e;
  border-radius: 8px;
  font-size: 0.85rem;
}

.mtc-fieldset {
  border: none;
  margin: 0;
  padding: 0;
  min-width: 0;
}

.mtc-section {
  margin-bottom: 1.15rem;
  padding: 1rem;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: #fafbfc;
}

.mtc-section__title {
  margin: 0 0 0.85rem;
  font-size: 0.88rem;
  font-weight: 750;
  color: #0f766e;
  display: flex;
  align-items: center;
  gap: 0.45rem;
}

.mtc-section__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.85rem 1rem;
}

.mtc-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  min-width: 0;
}

.mtc-field--full {
  grid-column: 1 / -1;
}

.mtc-note {
  margin: 0;
  padding: 0.65rem 0.8rem;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  color: #9a3412;
  border-radius: 8px;
  font-size: 0.78rem;
  line-height: 1.45;
}

.mtc-field__label {
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--text-muted);
  letter-spacing: 0.02em;
}

.mtc-field__hint {
  font-size: 0.72rem;
  color: var(--text-muted);
  line-height: 1.35;
}

.mtc-field input,
.mtc-field select,
.mtc-field textarea {
  width: 100%;
  padding: 0.5rem 0.7rem;
  font-size: 0.875rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text);
}

.mtc-field input:focus,
.mtc-field select:focus,
.mtc-field textarea:focus {
  outline: none;
  border-color: #0f766e;
}

.mtc-field input:disabled,
.mtc-field select:disabled {
  background: #f1f5f9;
  color: #94a3b8;
}

.mtc-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.mtc-chips--wrap {
  max-height: 160px;
  overflow-y: auto;
  padding: 0.15rem 0;
}

.mtc-chip {
  font-family: inherit;
  font-size: 0.75rem;
  font-weight: 650;
  padding: 0.3rem 0.6rem;
  border-radius: 999px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #64748b;
  cursor: pointer;
}

.mtc-chip--on {
  background: #ecfdf5;
  border-color: #a7f3d0;
  color: #047857;
}

.mtc-chip:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.mtc-pair-add {
  display: flex;
  gap: 0.5rem;
}

.mtc-pair-add__btn {
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 650;
  padding: 0.45rem 0.85rem;
  border-radius: 8px;
  border: 1px solid rgba(15, 118, 110, 0.3);
  background: #f0fdfa;
  color: #0f766e;
  white-space: nowrap;
}

.mtc-modal__footer {
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 0.9rem 0 1.15rem;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.4) 0%, #fff 35%);
}

.mtc-history-list {
  margin: 0.4rem 0 0;
  padding-left: 1.1rem;
  font-size: 0.8rem;
  color: var(--text);
  line-height: 1.45;
}

@media (max-width: 720px) {
  .mtc-section__grid {
    grid-template-columns: 1fr;
  }

  .mtc-modal {
    max-height: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/CopyTrading/MasterTraderConfigModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,wBAAwB;EACxB,sCAAsC;EACtC,0DAA0D;EAC1D,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;;;EAGE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,0EAA0E;AAC5E;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".mtc-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1100;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 1.25rem 1rem;\n  overflow-y: auto;\n}\n\n.mtc-modal {\n  background: #fff;\n  border-radius: 14px;\n  width: 100%;\n  max-width: 880px;\n  margin: 1.5rem 0;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.22);\n  display: flex;\n  flex-direction: column;\n  max-height: calc(100vh - 3rem);\n}\n\n.mtc-modal__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1.15rem 1.35rem;\n  border-bottom: 1px solid var(--border);\n  background: linear-gradient(180deg, #f0fdfa 0%, #fff 100%);\n  border-radius: 14px 14px 0 0;\n}\n\n.mtc-modal__header h3 {\n  margin: 0 0 0.25rem;\n  font-size: 1.15rem;\n  font-weight: 750;\n  color: var(--text);\n}\n\n.mtc-modal__header p {\n  margin: 0;\n  font-size: 0.82rem;\n  color: var(--text-muted);\n}\n\n.mtc-modal__close {\n  width: 34px;\n  height: 34px;\n  border: 1px solid var(--border);\n  background: #fff;\n  border-radius: 8px;\n  color: var(--text-muted);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.mtc-modal__close:hover {\n  color: #0f766e;\n  border-color: #0f766e;\n}\n\n.mtc-modal__body {\n  overflow-y: auto;\n  padding: 1rem 1.35rem 0.5rem;\n}\n\n.mtc-error {\n  margin: 0 0 1rem;\n  padding: 0.7rem 0.9rem;\n  background: #fee2e2;\n  color: #b91c1c;\n  border-radius: 8px;\n  font-size: 0.85rem;\n}\n\n.mtc-loading {\n  margin: 0 0 1rem;\n  padding: 0.7rem 0.9rem;\n  background: #f0fdfa;\n  color: #0f766e;\n  border-radius: 8px;\n  font-size: 0.85rem;\n}\n\n.mtc-fieldset {\n  border: none;\n  margin: 0;\n  padding: 0;\n  min-width: 0;\n}\n\n.mtc-section {\n  margin-bottom: 1.15rem;\n  padding: 1rem;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  background: #fafbfc;\n}\n\n.mtc-section__title {\n  margin: 0 0 0.85rem;\n  font-size: 0.88rem;\n  font-weight: 750;\n  color: #0f766e;\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.mtc-section__grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.85rem 1rem;\n}\n\n.mtc-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  min-width: 0;\n}\n\n.mtc-field--full {\n  grid-column: 1 / -1;\n}\n\n.mtc-note {\n  margin: 0;\n  padding: 0.65rem 0.8rem;\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n  color: #9a3412;\n  border-radius: 8px;\n  font-size: 0.78rem;\n  line-height: 1.45;\n}\n\n.mtc-field__label {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--text-muted);\n  letter-spacing: 0.02em;\n}\n\n.mtc-field__hint {\n  font-size: 0.72rem;\n  color: var(--text-muted);\n  line-height: 1.35;\n}\n\n.mtc-field input,\n.mtc-field select,\n.mtc-field textarea {\n  width: 100%;\n  padding: 0.5rem 0.7rem;\n  font-size: 0.875rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text);\n}\n\n.mtc-field input:focus,\n.mtc-field select:focus,\n.mtc-field textarea:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.mtc-field input:disabled,\n.mtc-field select:disabled {\n  background: #f1f5f9;\n  color: #94a3b8;\n}\n\n.mtc-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.mtc-chips--wrap {\n  max-height: 160px;\n  overflow-y: auto;\n  padding: 0.15rem 0;\n}\n\n.mtc-chip {\n  font-family: inherit;\n  font-size: 0.75rem;\n  font-weight: 650;\n  padding: 0.3rem 0.6rem;\n  border-radius: 999px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #64748b;\n  cursor: pointer;\n}\n\n.mtc-chip--on {\n  background: #ecfdf5;\n  border-color: #a7f3d0;\n  color: #047857;\n}\n\n.mtc-chip:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.mtc-pair-add {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.mtc-pair-add__btn {\n  font-family: inherit;\n  font-size: 0.85rem;\n  font-weight: 650;\n  padding: 0.45rem 0.85rem;\n  border-radius: 8px;\n  border: 1px solid rgba(15, 118, 110, 0.3);\n  background: #f0fdfa;\n  color: #0f766e;\n  white-space: nowrap;\n}\n\n.mtc-modal__footer {\n  position: sticky;\n  bottom: 0;\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding: 0.9rem 0 1.15rem;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.4) 0%, #fff 35%);\n}\n\n.mtc-history-list {\n  margin: 0.4rem 0 0;\n  padding-left: 1.1rem;\n  font-size: 0.8rem;\n  color: var(--text);\n  line-height: 1.45;\n}\n\n@media (max-width: 720px) {\n  .mtc-section__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .mtc-modal {\n    max-height: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
